export default {
  label: "Benutzerverwaltung",
};
